/**
 * Initializes Google Analytics with consent flags.
 * Guards against multiple inits and retries once on failure.
 */
export function initGA() {
  // Grant all
  window.gtag('consent', 'update', {
    ad_storage: 'granted',
    analytics_storage: 'granted'
  });
  window.dataLayer.push({ event: 'cookie_consent_granted' });
}

/**
 * Disables Google Analytics by setting denied consent flags.
 */
export function disableGA() {
  // Deny all
  window.gtag('consent', 'update', {
    ad_storage: 'denied',
    analytics_storage: 'denied'
  });
  window.dataLayer.push({ event: 'cookie_consent_denied' });
}